// extracted by mini-css-extract-plugin
export default {"invoices":"Invoices_invoices__1VNMf","invoices-table":"Invoices_invoices-table__KYZFm"};